import { createContext, useContext, useEffect, useState } from 'react';
import { publicApi } from '@/lib/api';

const SiteContext = createContext(null);

export const SiteProvider = ({ children }) => {
    const [settings, setSettings] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let mounted = true;
        publicApi
            .getSiteSettings()
            .then((s) => {
                if (mounted) setSettings(s);
            })
            .catch(() => {})
            .finally(() => mounted && setLoading(false));
        return () => {
            mounted = false;
        };
    }, []);

    return (
        <SiteContext.Provider value={{ settings, loading }}>{children}</SiteContext.Provider>
    );
};

export const useSite = () => {
    const ctx = useContext(SiteContext);
    if (!ctx) throw new Error('useSite must be used within SiteProvider');
    return ctx;
};
